import { Label } from "semantic-ui-react";
import React from "react";

export const PriceTierLabel = ({ priceTier = {} }) => (
    <Label as="span" color={priceTier.is_base_tier ? "green" : priceTier.color || "grey"}>
        {priceTier.name}
        <Label.Detail>{priceTier.percentage}%</Label.Detail>
    </Label>
);
